import React, {useEffect} from 'react'
import { useDispatch } from 'react-redux'
import './App.css'

import NavBar from './components/navigation/NavBar'
import About from './components/pages/About'
import AttributionRules from './components/pages/AttributionRules'
import Favourites from './components/pages/Favourites'
import Home from './components/pages/Home'
import Start from './components/pages/Start'
import Login from './components/pages/Login'
import ForgotPassword from './components/pages/ForgotPassword'
import Policies from "./components/pages/Policies";
import Profile from './components/pages/Profile'
import Request from './components/pages/Request'
import ResourceSearchPage from './components/pages/ResourceSearchPage'
import RESOURCE_SEARCH_PAGES from './components/pages/resourceSearchPages'
import Terminology from './components/pages/Terminology'
import RequestTerm from './components/pages/RequestTerm'
import SignUp from './components/pages/SignUp'
import NotFound from './components/pages/NotFound'
import Admin from './components/admin/Admin'
import ManageAdmin from './components/admin/ManageAdmin'
import ManageResources from './components/admin/ManageResources'
import ConfirmForgotPassword from './components/pages/ConfirmForgotPassword'
import Activate from './components/pages/Activate'
import ConfirmEmail from './components/pages/ConfirmEmail'
import ManageTags from './components/admin/ManageTags'
import ManageAutomation from './components/admin/ManageAutomation'
import TerminologyAdmin from './components/admin/TerminologyAdmin'
import RequireStaff, { TERMINOLOGY_ADMIN_MESSAGE, isTerminologyAdminAuthorized } from './components/navigation/RequireStaff'
import Quiz from './components/pages/Quiz'
import Recommended from './components/pages/Recommended'
import TCAIREMResources from './components/pages/TCAIREMResources'
import Chatbot from './components/pages/Chatbot'

import Notification from './components/notifications/Notification'

import { PAGES } from './components/navigation/routes'
import resourcesService from './services/resourceService'

import { ThemeProvider } from '@mui/material/styles'
import { getTheme } from './components/styles'

import { Routes, Route } from 'react-router-dom'
import Footer from './components/footer/Footer'

import { setUserOnRefresh } from './reducers/userReducer'

// ScrollToTop is a wrapper for the router to make the page go to the top when swapping to new component
// router used to do this for you weird that it doesn't anymore
import ScrollToTop from './components/navigation/ScrollToTop'

// Inline route-shape objects for RequireStaff. Hoisted to module scope so
// they don't create a new object identity on every App render.
const STAFF_ROUTE = { staff: true }
const TERMINOLOGY_ADMIN_ROUTE = { terminology_admin: true }

const App = () => {
    const theme = getTheme()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setUserOnRefresh())
    }, [dispatch])

    return (
        <ThemeProvider theme={theme}>
            <NavBar />
            <Notification />
            <ScrollToTop>
                <Routes>
                    <Route path='*' element={<NotFound />} />
                    <Route path={PAGES.home.path} element={<Home />} />
                    <Route path={PAGES.about.path} element={<About />} />
                    <Route path={PAGES.start.path} element={<Start />} />
                    <Route path={PAGES.login.path} element={<Login />} />
                    <Route path={PAGES.forgot_password.path} element={<ForgotPassword />} />
                    <Route path={PAGES.confirm_forgot_password.path} element={<ConfirmForgotPassword />} />
                    <Route path={PAGES.sign_up.path} element={<SignUp />} />
                    <Route path={PAGES.activate.path} element={<Activate />} />
                    <Route path={PAGES.confirm_email.path} element={<ConfirmEmail />} />
                    {RESOURCE_SEARCH_PAGES.flatMap(({ page, ...pageProps }) => {
                        const element = (
                            <ResourceSearchPage
                                pageTitle={page.title}
                                pagePath={page.path}
                                fetchResource={resourcesService.retrieveSingle}
                                {...pageProps}
                            />
                        )
                        return [
                            <Route key={page.path} path={page.path} element={element} />,
                            <Route key={`${page.path}:id`} path={`${page.path}:id`} element={element} />,
                        ]
                    })}
                    <Route path={PAGES.policies.path} element={<Policies />} />
                    <Route path={`${PAGES.policies.path}:id`} element={<Policies />} />
                    <Route path={PAGES.terminology.path} element={<Terminology />} />
                    <Route path={`${PAGES.terminology.path}:id`} element={<Terminology />} />
                    <Route path={PAGES.suggest_term.path} element={<RequestTerm />} />
                    <Route path={PAGES.profile.path} element={<Profile />} />
                    <Route path={PAGES.favourites.path} element={<Favourites />} />
                    <Route element={<RequireStaff route={STAFF_ROUTE} />}>
                        <Route path={PAGES.admin_portal.path} element={<Admin />} />
                        <Route path={PAGES.manage_admin.path} element={<ManageAdmin />} />
                        <Route path={PAGES.manage_resources.path} element={<ManageResources />} />
                        <Route path={PAGES.manage_tags.path} element={<ManageTags />} />
                        <Route path={PAGES.manage_automation.path} element={<ManageAutomation />} />
                        <Route path={PAGES.create_resource.path} element={<Request />} />
                    </Route>
                    <Route element={<RequireStaff route={TERMINOLOGY_ADMIN_ROUTE} message={TERMINOLOGY_ADMIN_MESSAGE} isAuthorized={isTerminologyAdminAuthorized} />}>
                        <Route path={PAGES.terminology_admin.path} element={<TerminologyAdmin />} />
                    </Route>
                    <Route path={PAGES.quiz.path} element={<Quiz />} />
                    <Route path={PAGES.recommended.path} element={<Recommended />} />
                    <Route path={PAGES.attributionRules.path} element={<AttributionRules />} />
                    <Route path={PAGES.tcairemResources.path} element={<TCAIREMResources />} />
                    <Route path={`${PAGES.tcairemResources.path}:id`} element={<TCAIREMResources />} />
                    <Route path={PAGES.chatbot.path} element={<Chatbot />} />
                </Routes>
            </ScrollToTop>
            <Footer />
        </ThemeProvider>
    )
}

export default App
